import { Language } from 'store/slices/language-slice';

interface UpdatePasswordMessages {
  backButton: string;
  passwordsSameError: string;
  changePassword: {
    heading: string;
    subHeading: string;
    oldPasswordLabel: string;
    newPasswordLabel: string;
    confirmPasswordLabel: string;
    nextButton: string;
  };
  askForTwoFactor: {
    heading: string;
    subHeading: string;
    verificationCodeHeading: string;
    havingTroubleHeading: string;
    havingTroubleMessagePart1: string;
    havingTroubleMessagePart2: string;
    continueButton: string;
    twoFactorErrorMessage: string;
  };
  accountUpdated: {
    thumbsUpAlt: string;
    heading: string;
    continueButton: string;
  };
  otp: {
    title: string;
  };
  passwordRequirements: {
    heading: string;
    passwordsMatch: string;
    uppercaseLetter: string;
    lowercaseLetter: string;
    character: string;
    number: string;
  };
}

type Messages = {
  [key in Language]: UpdatePasswordMessages;
};

const messages: Messages = {
  en: {
    backButton: 'Back',
    passwordsSameError: 'Old and new passwords cannot be the same',
    changePassword: {
      heading: 'Change Password',
      subHeading: 'Please enter your new password',
      oldPasswordLabel: 'Old password',
      newPasswordLabel: 'New password',
      confirmPasswordLabel: 'Confirm new password',
      nextButton: 'Next',
    },
    askForTwoFactor: {
      heading: 'Two-factor Authentication',
      subHeading: 'Please enter your 2FA verification code',
      verificationCodeHeading: 'Enter verification code',
      havingTroubleHeading: 'Having trouble?',
      havingTroubleMessagePart1: 'Send as an email at ',
      havingTroubleMessagePart2:
        ' or click on the chat button on the bottom right for assistance.',
      continueButton: 'Continue',
      twoFactorErrorMessage: 'Incorrect pin provided',
    },
    accountUpdated: {
      thumbsUpAlt: 'Success',
      heading: 'Account successfully updated',
      continueButton: 'Continue',
    },
    otp: {
      title: 'Confirm password update',
    },
    passwordRequirements: {
      heading: 'Minimum requirements',
      passwordsMatch: 'Passwords match',
      uppercaseLetter: '1 uppercase letter',
      lowercaseLetter: '1 lowercase letter',
      character: '6 characters',
      number: '1 number',
    },
  },
};

export default messages;
